import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { StateService } from '@uirouter/angular';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventSubscriptionListComponent } from '../../../../widgets/event-subscription-list/event-subscription-list.component';
import { EventSubscriptionModalComponent } from '../../../../widgets/event-subscription-modal/event-subscription-modal.component';

@Component({
    selector: 'admin-webhooks',
    template: require('./admin.webhooks.component.html'),
})
export class AdminWebhooksComponent implements OnInit {
    @ViewChild(EventSubscriptionListComponent) subscriptionList: EventSubscriptionListComponent;

    $state: StateService;

    constructor(
        private titleService: Title,
        private stateService: StateService,
        private modalService: NgbModal,
    ) {
        this.$state = stateService;
    }

    ngOnInit() {
        this.titleService.setTitle('Webhooks');
    }

    get showSubscriptions(): boolean {
        return this.stateService.includes('home.admin.webhooks.subscriptions');
    }

    private openModal(subscriptionId: number) {
        const ref = this.modalService.open(EventSubscriptionModalComponent, { size: 'lg' });
        ref.componentInstance.subscriptionId = subscriptionId;
        ref.componentInstance.projectId = null;
        ref.result.then(() => {
            if (this.subscriptionList) { this.subscriptionList.load(); }
        }, () => {});
    }

    onEdit(id: number) { this.openModal(id); }
    onCreate() { this.openModal(0); }
}
